export default __webpack_public_path__ + "static/media/airplane_dark.f2f6da6a.png";